/** @format */

// /** @format */

// import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import Navbar from "./components/Navbar";
// import Sharing from "./components/TopNavRedux.js";
// import Footer from "./components/Footer";
// import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
// import Home from "./components/pages/Home";
// import ContactUs from "./components/pages/ContactUs";
// import AboutUs from "./components/pages/AboutUs";
// import Team from "./components/pages/Team";
// import PayersPage from "./components/pages/solutions/Payers";
// import ProvidersPage from "./components/pages/solutions/Providers";
// import SchoolsPage from "./components/pages/solutions/Schools";
// import ParentsPage from "./components/pages/solutions/Parents";
// import SolutionsPage from "./components/pages/solutions/Solutions";
// import Science from "./components/pages/Science";
// import KbroFeatures from "./components/pages/solutions/KbroFeatures";
// import KbroUsers from "./components/pages/solutions/KbroUsers";
// import TermsofUse from "./components/pages/TermsofUse";
// import Privacy from "./components/pages/Privacy";
// import Faq from "./components/Faq";
// import Press from "./components/Press";
// import HeroSection from "./components/HeroSection";
// import Careers from "./components/pages/Careers";
// import Dealwith from "./components/Dealwith";
// import Speakup from "./components/Speakup";
// import WhatsUp from "./components/WhatsUp";
// import Konnect345 from "./components/pages/Konnect345";
// import Konnect654 from "./components/pages/konnect654.js";

// function App() {
//   return (
//     <Router>
//       <Sharing />
//       <Navbar />
//       <Switch>
//         <Route path="/" exact component={Home} />
//         <Route path="/sliders" component={HeroSection} />
//         <Route path="/contact" exact component={ContactUs} />
//         <Route path="/about" exact component={AboutUs} />
//         <Route path="/team" component={Team} />
//         <Route path="/science" component={Science} />
//         <Route path="/payers" component={PayersPage} />
//         <Route path="/providers" component={ProvidersPage} />
//         <Route path="/schools" component={SchoolsPage} />
//         <Route path="/parents" component={ParentsPage} />
//         <Route path="/kbrofeatures" component={KbroFeatures} />
//         <Route path="/kbrousers" component={KbroUsers} />
//         <Route path="/solutions" component={SolutionsPage} />
//         <Route path="/termsofuse" component={TermsofUse} />
//         <Route path="/privacy" component={Privacy} />
//         <Route path="/faqs" component={Faq} />
//         <Route path="/press" component={Press} />
//         <Route path="/careers" component={Careers} />
//         <Route path="/dealwith" component={Dealwith} />
//         <Route path="/speakup" component={Speakup} />
//         <Route path="/whatsup" component={WhatsUp} />
//         <Route path="/konnect345" component={Konnect345} />
//         <Route path="/konnect654" component={Konnect654} />
//       </Switch>
//       <Footer />
//     </Router>
//   );
// }

// export default App;

/** @format */

import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Navbar from "./components/Navbar";
import Sharing from "./components/TopNavRedux.js";
import Footer from "./components/Footer";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "./components/pages/Home";
import ContactUs from "./components/pages/ContactUs";
import AboutUs from "./components/pages/AboutUs";
import Team from "./components/pages/Team";
import PayersPage from "./components/pages/solutions/Payers";
import ProvidersPage from "./components/pages/solutions/Providers";
import SchoolsPage from "./components/pages/solutions/Schools";
import ParentsPage from "./components/pages/solutions/Parents";
import SolutionsPage from "./components/pages/solutions/Solutions";
import Science from "./components/pages/Science";
import KbroFeatures from "./components/pages/solutions/KbroFeatures";
import KbroUsers from "./components/pages/solutions/KbroUsers";
import TermsofUse from "./components/pages/TermsofUse";
import Privacy from "./components/pages/Privacy";
import Faq from "./components/Faq";
import Press from "./components/Press";
import HeroSection from "./components/HeroSection";
import Careers from "./components/pages/Careers";
import Dealwith from "./components/Dealwith";
import Speakup from "./components/Speakup";
import WhatsUp from "./components/WhatsUp";
import Konnect345 from "./components/pages/Konnect345";
import Konnect654 from "./components/pages/konnect654.js";

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/konnect345">
          <Navbar />
          <Konnect345 />
        </Route>
        <Route path="/konnect654">
          <Navbar />
          <Konnect654 />
        </Route>

        <Route>
          <>
            <Sharing />
            <Navbar />
            <Switch>
              <Route path="/" exact component={Home} />
              <Route path="/sliders" component={HeroSection} />
              <Route path="/contact" exact component={ContactUs} />
              <Route path="/about" exact component={AboutUs} />
              <Route path="/team" component={Team} />
              <Route path="/science" component={Science} />
              <Route path="/payers" component={PayersPage} />
              <Route path="/providers" component={ProvidersPage} />
              <Route path="/schools" component={SchoolsPage} />
              <Route path="/parents" component={ParentsPage} />
              <Route path="/kbrofeatures" component={KbroFeatures} />
              <Route path="/kbrousers" component={KbroUsers} />
              <Route path="/solutions" component={SolutionsPage} />
              <Route path="/termsofuse" component={TermsofUse} />
              <Route path="/privacy" component={Privacy} />
              <Route path="/faqs" component={Faq} />
              <Route path="/press" component={Press} />
              <Route path="/careers" component={Careers} />
              <Route path="/dealwith" component={Dealwith} />
              <Route path="/speakup" component={Speakup} />
              <Route path="/whatsup" component={WhatsUp} />
            </Switch>
          </>
        </Route>
      </Switch>
      <Footer />
    </Router>
  );
}

export default App;
